import ProfileAvatar from 'src/shared/features/users/components/profile-photos/profile-avatar'
import ProfileAvatarURL from 'src/shared/features/users/components/profile-photos/profile-avatar-url'
import { cn } from 'src/shared/utils/cn'

import type { TeamUserSummary } from '../shared/schemas/business'

type BusinessTeamMemberAvatarsProps = {
  teamMembers?: TeamUserSummary[] | null
  size?: number
  className?: string
}

const BusinessTeamMemberAvatars = ({ teamMembers, size = 40, className }: BusinessTeamMemberAvatarsProps) => {
  const members = teamMembers ?? []

  if (members.length === 0) {
    return null
  }

  const width = size + (members.length - 1) * (size / 2)

  return (
    <div className={cn('relative', className)} style={{ height: size, width }}>
      {members.map((member, index) => {
        const photoUrl = member.userProfilePhoto || undefined

        return (
          <div
            key={`${member.userId}-${index}`}
            className="absolute top-0"
            style={{ left: (index * size) / 2, width: size, height: size, zIndex: index + 1 }}
          >
            <div className="flex size-full items-center justify-center rounded-full border-2 border-white bg-white shadow-[0_1px_6px_1px_rgba(27,48,41,0.15)]">
              {photoUrl ? (
                <ProfileAvatarURL photoUrl={photoUrl} size={size - 4} />
              ) : (
                <ProfileAvatar userId={member.userId} size={size - 4} />
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default BusinessTeamMemberAvatars
